import styled from 'foundations-theming/utils';
import { Draggable } from 'react-beautiful-dnd';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { DragHandleHoverContainer } from 'foundations-components/transitional/components/DragHandleHoverContainer';
import { DragHandle as FoundationsDragHandle } from 'foundations-components/transitional/components/DragHandle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DragHandle = styled.div.withConfig({
  displayName: "SortableListItem__DragHandle",
  componentId: "sc-1l6q29w-0"
})([":hover{display:block;background-color:", ";}"], ({
  theme
}) => theme.color['border-core-subtle']);
const SortableListItem = ({
  children,
  index
}) => /*#__PURE__*/_jsx(Draggable, {
  disableInteractiveElementBlocking: true,
  draggableId: children.props.sortKey,
  index: index,
  children: provided => {
    return /*#__PURE__*/_jsx("div", Object.assign({
      ref: provided.innerRef
    }, provided.draggableProps, provided.dragHandleProps, {
      tabIndex: -1,
      children: /*#__PURE__*/_jsx(DragHandleHoverContainer, {
        children: /*#__PURE__*/_jsxs(TFlex, {
          align: "center",
          children: [/*#__PURE__*/_jsx(DragHandle, {
            children: /*#__PURE__*/_jsx(FoundationsDragHandle, {})
          }), children]
        })
      })
    }));
  }
});
SortableListItem.displayName = 'SortableListItem';
export default SortableListItem;